import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Card from 'primevue/card'
import { withDefaults, computed } from 'vue'
import environment from '@/configs/environtment'

interface IPropsCard {
  isInvalid?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomBlueBorder',
  props: {
    isInvalid: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { isInvalid: boolean }

const isProduction = computed(() => environment.getMode() === 'production')




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), {
    class: _normalizeClass(`card-no-shadow card-rounded-3xl ${props.isInvalid ? 'background-grey-200' : _unref(isProduction) ? 'card-border-primary-500' : 'card-border-secondary-500'}`)
  }, {
    content: _withCtx(() => [
      _renderSlot(_ctx.$slots, "body")
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})